import React from 'react';
import { cn, getStatusColor, capitalize } from '../lib/utils';

const StatusBadge = ({ status, size = 'default', className }) => {
    const sizeClasses = {
        sm: 'px-2 py-0.5 text-xs',
        default: 'px-2.5 py-1 text-xs',
        lg: 'px-3 py-1.5 text-sm'
    };

    return (
        <span
            className={cn(
                'badge rounded-full font-medium',
                getStatusColor(status),
                sizeClasses[size],
                className
            )}
            data-testid={`status-badge-${status?.toLowerCase()}`}
        >
            {capitalize(status)}
        </span>
    );
};

export default StatusBadge;
